export class ConnectGcpFolderRequest {
    'organizationId';
    'folderId';
    'managementServiceAccountId';
    'excludeProjectPatterns';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "organizationId",
            "baseName": "organizationId",
            "type": "string",
            "format": ""
        },
        {
            "name": "folderId",
            "baseName": "folderId",
            "type": "string",
            "format": ""
        },
        {
            "name": "managementServiceAccountId",
            "baseName": "managementServiceAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "excludeProjectPatterns",
            "baseName": "excludeProjectPatterns",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ConnectGcpFolderRequest.attributeTypeMap;
    }
    constructor() {
    }
}
